import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Navigation2 = createReactComponent("Navigation2", ["svg", defaultAttributes, [["polygon", {
  points: "12 2 19 21 12 17 5 21 12 2",
  key: "1ofcjk"
}]]]);
export default Navigation2;